<mat-card (contextmenu)="onContextMenu($event)" class="monitor-gray" [class.selected]="isSelected && isSelectionEnable"
  (click)="monitorClick($event)" cdkDropList (cdkDropListDropped)="drop($event)" (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()" (dblclick)="onDoubleClickHandler()" [cdkDropListData]="monitor"
  [id]="monitor.MonitorHandler" [cdkDropListEnterPredicate]="isSelectionEnable ? enterPredicate : falsePredicateFunction"
  [class.biggerMonitor]="viewMode === viewModes.Monitors" [class.carousel-monitor]="!isSelectionEnable"
  [class.full-screen-monitor]="isFullScreen">

  <mat-card-content class="monitor-picture">
    <img *ngIf="monitor.PictureURL; else loadingMonitorImg" [imageSrc]="monitor.PictureURL" draggable="false"
      [class.drop-border]="isDropEnabled && isSelectionEnable" [class.active]="isDropActive && isSelectionEnable" />
    <ng-template #loadingMonitorImg>
      <div class="card-monitor loading"></div>
    </ng-template>
  </mat-card-content>

  <ng-container *ngIf="isSelectionEnable">
    <mat-card-content class="monitor-overlay" *ngIf="monitor.Status == screenStatuses.Playing">
      <mat-progress-bar *ngIf="monitor.ScreenState.AppPercentProgress" class="greenline-progress" mode="determinate"
        [value]="monitor.ScreenState.AppPercentProgress" max="100"></mat-progress-bar>

      <div class="monitor-toolbar" #toolbar>
        <button [disabled]="monitor.ScreenState.ScreenContentMode == contentModes.SingleApp" class="btn-left"
          (click)="playPrevious($event)" mat-icon-button>
          <mat-icon matTooltip="Play Previous" svgIcon="fast_rewind"></mat-icon>
        </button>
        <div class="title-area" [matTooltip]="monitor.ScreenState.AppTimeLeft">
          <div class="title-lg">{{monitor.ScreenState.PlaylistTitle}}</div>
          <div class="title-md">{{getApplicationTitle(monitor.ScreenState)}}</div>
        </div>
        <button [disabled]="monitor.ScreenState.ScreenContentMode == contentModes.SingleApp" class="btn-right"
          (click)="playNext($event)" mat-icon-button>
          <mat-icon matTooltip="Play next" svgIcon="fast_forward"></mat-icon>
        </button>
      </div>
    </mat-card-content>

    <mat-card-content class="monitor-overlay-checkbox">
      <mat-icon class="monitor-exception-notification d-none d-md-block" *ngIf="monitor.errorData" svgIcon="alert"
        [matTooltip]="monitor.errorData.Message"></mat-icon>
      <mat-checkbox disableRipple [checked]="isSelected" class="light" (click)="handleCheckBoxClick($event)">
      </mat-checkbox>
    </mat-card-content>

    <mat-card-content class="d-block d-md-none buttn" (click)="$event.stopPropagation()">
      <button class="play" *ngIf="monitor.Status != screenStatuses.Playing" mat-icon-button
        (click)="monitor.playPlaylist(this.monitor.AssignedPlaylist)">
        <mat-icon class="large-icon" svgIcon="play_arrow" matTooltip="Start Playlist"></mat-icon>
      </button>

      <button class="stop" *ngIf="monitor.Status == screenStatuses.Playing" mat-icon-button
        (click)="monitor.stopPlaylist()">
        <mat-icon class="large-icon" svgIcon="stop" matTooltip="Stop Playlist"></mat-icon>
      </button>
    </mat-card-content>
  </ng-container>

  <div class="monitor-name position-absolute" *ngIf="showScreenName" [class.carousel-monitor-name]="!isSelectionEnable">
    <span *ngIf="!updateNameMode">{{ isFullScreen ? monitor.ScreenName : monitor.MonitorTitle }}</span>
    <input #monitorName [ngClass]="{'monitor-name__visible': updateNameMode }" [value]="monitor.MonitorTitle"
      (keyup.enter)="saveMonitorTitle(monitorName?.value)" (blur)="saveMonitorTitle()">
  </div>
</mat-card>
